import type { LinkField } from '@/types/api'

/** `target`/`rel` attributes for a CMS link; new-tab links never get access to `window.opener`. */
export function linkTargetProps (target?: LinkField['target'] | null) {
	return {
		target: target || undefined,
		rel: target === '_blank' ? 'noopener noreferrer' : undefined
	}
}
